export default __webpack_public_path__ + "static/16-c76998da69b522a3f516ae6cc1f1ec38.png";